import { T } from "@supersig/validate";
import { idValidator } from "../misc/id-validator";
export const baseResourceValidatorSharedMap = {
    name: T.string,
    description: T.string.optional(),
    version: T.number,
    previewUrl: T.string.optional(),
    organizationId: T.number,
    scope: T.literalEnum("global", "organization"),
    versioningHash: T.string.optional()
};
/** @public */ export const resourceIdValidator = idValidator("resource");
/** @public */ export function createResourceValidator(type, props, meta) {
    return T.object({
        id: resourceIdValidator,
        typeName: T.literal("resource"),
        type: T.literal(type),
        props: props ? T.object(props) : T.jsonValue,
        meta: meta ? T.object(meta) : T.jsonValue,
        ...baseResourceValidatorSharedMap
    });
}
